<template>
	<div class='setgetlist'>
		<div v-for='(item,ind) in setgetlist' class='warp_bor' :style='{width:ind==2||ind==3 ? item:"50%"}'>
			<div v-if='ind==0||ind==1' :class='ind%2?"color1":"color2"' style="text-align: center;">{{item}}</div>
			<div v-else-if='ind==2||ind==3' 
			:style='{background:ind==2?"#96b5ef":ind==3?"#f7bebd":"",
			textAlign:ind == 3 ?"right":"left",color:ind==2?"#000099":ind==3?"#59111c":""}' style="font-size: 1rem;">{{item}}</div>
			<div v-else :class='ind%2?"color1":"color2"'>{{item}}</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['setgetlist'],
	}
</script>

<style lang='scss'>
	.warp_bor {
			display: inline-block;
			width: 50%;
		}
		.warp_bor>div{
			font-weight: 600;
			text-align: right;
			font-size:1.3rem;
		}
	.setgetlist {
		.color2 {
			background-color: #bfd9f2;
		}

		.color1 {
			background-color: #e3effb;
		}
	}
</style>
